import { AssetRef, MediaType, MetaType } from "../types"
import {
  actionCreatorGuard,
  reducerGuard,
  processActionMeta,
  getArrayReducerGuard
} from "../reducers"

const kind = "library"

export type Media = {
  kind: typeof kind
  version: number
  type: MediaType
  name: string
  snap_id: string
  bucket: string
  assets: Array<AssetRef>
  meta: MetaType
  altText: string
}

export const reducerAction = {
  meta: actionCreatorGuard<Media, MetaType>("meta", kind),
  assets: actionCreatorGuard<Media, Array<AssetRef>>("assets", kind),
  type: actionCreatorGuard<Media, string>("type", kind),
  name: actionCreatorGuard<Media, string>("name", kind),
  bucket: actionCreatorGuard<Media, string>("bucket", kind),
  snap_id: actionCreatorGuard<Media, string>("snap_id", kind),
  altText: actionCreatorGuard<Media, string>("altText", kind)
}

// Type safety to ensure we have a defined action for each property
type ReducerActions = {
  [key in keyof Omit<Media, "kind" | "version">]: (typeof reducerAction)[key][0]
}

// Our exported actions
export const libraryAction = Object.fromEntries(
  Object.entries(reducerAction).map(k => [k[0], k[1][0]])
) as ReducerActions

export const libraryReducer = reducerGuard<Media>(kind)
  .case(...reducerAction.meta)
  .case(...reducerAction.assets)
  .case(...reducerAction.type)
  .case(...reducerAction.name)
  .case(...reducerAction.altText)
  .case(...reducerAction.bucket)
  .case(...reducerAction.snap_id)
  .default((prevState, action: any) => {
    action = processActionMeta(action)

    switch (action?.meta?.prop) {
      case "assets":
        return getArrayReducerGuard<Media, AssetRef>(
          kind,
          "assets",
          "AssetRef",
          prevState,
          action
        )
    }

    return prevState
  })
